import React from "react";

const StorefrontRedirectNotice = ({ config }) => (
  <section className="storefront-redirect">
    <div className="storefront-redirect__content">
      <h2>Checkout notice</h2>
      <p>{config.policies.redirectNotice}</p>
    </div>
  </section>
);

export default StorefrontRedirectNotice;
